import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { SettingsIcon } from 'foundations-assets/icons/components/SettingsIcon';
import ManageVariantsLink from 'personalization-lib/components/shared/links/ManageVariantsLink';
import ContentEditorCreateVariantButton from 'personalization-lib/components/variantCreation/ContentEditorCreateVariantButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VariantSelectFooter = ({
  strategyId,
  onCreateClick
}) => /*#__PURE__*/_jsxs(Flex, {
  flexDirection: "column",
  gap: "400",
  children: [/*#__PURE__*/_jsx(ContentEditorCreateVariantButton, {
    buttonProps: {
      use: 'link'
    },
    tooltipProps: {
      placement: 'left'
    },
    label: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(IconHolder, {
        icon: AddIcon,
        size: "300",
        compact: true
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "personalizationLib.variantSelect.footer.addVariant"
      })]
    }),
    onClick: onCreateClick
  }), /*#__PURE__*/_jsx(View, {
    children: /*#__PURE__*/_jsx(ManageVariantsLink, {
      label: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(IconHolder, {
          icon: SettingsIcon,
          size: "300",
          marginInlineEnd: "200",
          compact: true
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "personalizationLib.shared.manageVariants"
        })]
      }),
      strategyId: strategyId
    })
  })]
});
export default VariantSelectFooter;